/**
 * Query-param navigation model for /incident. All views share the single route:
 * ?id=<workspaceId>&v=<view>&step=<stepId>&p=<pageIndex> — pushed with router.push
 * so the browser Back button works.
 */
export type IncidentViewId = "intro" | "index" | "step" | "answers" | "timeline" | "evidence" | "contacts" | "assignments" | "summary" | "harden"

export const INCIDENT_VIEW_IDS: readonly IncidentViewId[] = [
  "intro", "index", "step", "answers", "timeline", "evidence", "contacts", "assignments", "summary", "harden",
]

export interface IncidentNav {
  v: IncidentViewId
  step?: string
  p?: number
  /** Element id to scroll to after navigating (e.g. "field-dataTaken"). */
  hash?: string
}

export type GoTo = (nav: IncidentNav) => void

export function incidentHref(workspaceId: string, nav: IncidentNav): string {
  const q = new URLSearchParams({ id: workspaceId, v: nav.v })
  if (nav.step !== undefined) q.set("step", nav.step)
  if (nav.p !== undefined) q.set("p", String(nav.p))
  const base = `/incident?${q.toString()}`
  return nav.hash ? `${base}#${nav.hash}` : base
}
